module.exports = __webpack_public_path__ + "static/media/tangouno.480105e9.png";